<div class="policy-endpoint-filtering">
    <div class="policy-endpoint-filtering-add" *ngIf="(isLoading$ | async) === false">
        <div class="policy-endpoint-filtering-add-text">
            <div class="policy-endpoint-filtering-add-text-description">
                {{ "policyPage.config.endpointFilteringContent.allowedEndpointsDesc" | labelsProvider }}
            </div>
        </div>
        <div class="policy-endpoint-filtering-add-button" *ngIf="editable">
            <button class="add-hostname-button" (click)="addEndpointClicked()">
                <span>{{ "policyPage.config.endpointFilteringContent.addEndpoint" | labelsProvider }}</span>
            </button>
        </div>
    </div>
    <div class="divider" *ngIf="(isLoading$ | async) === false"></div>
    <div class="policy-endpoint-filtering-table-section" *ngIf="(isLoading$ | async) === false">
        <div class="policy-endpoint-filtering-table-section-title">
            {{ "policyPage.config.endpointFilteringContent.allowedEndpoints" | labelsProvider }}
        </div>
        <app-effective-policy-settings-button
            class="policy-field-effective-policy-settings-button"
            [effectivePolicySetting]="EffectivePolicySettingEnum.endpoints"
            [platform]="integrationModel.platform">
        </app-effective-policy-settings-button>
        <div class="policy-endpoint-filtering-table-section-body" *ngIf="(isLoading$ | async) === false">
            <div class="policy-endpoint-filtering-table-section-body-search">
                <app-autocomplete-search
                    class="policy-endpoint-filtering-table-section-body-search-box"
                    placeholder="Search..."
                    (autocompleteOnChange)="endpointSearched($event)"
                    [values]="endpointsUrls"
                    [resetSearchBox$]="resetSearchBoxBehavioralSubject$"></app-autocomplete-search>
            </div>

            <p-table [scrollable]="true" [value]="(endpointsCurrentPage$ | async) ?? []" class="main-table">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Endpoint</th>
                        <!-- Actions Column -->
                        <th style="width: 50px"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-endpoint>
                    <tr class="table-row">
                        <td style="width: 100%">{{ endpoint.url }}</td>

                        <td style="width: 50px">
                            <div class="delete-column-icon" (click)="$event.stopPropagation()">
                                <img
                                    *ngIf="editable"
                                    src="assets/images/common/delete.svg"
                                    class="delete-icon"
                                    (click)="enableRemoveEndpoint && removeEndpointClicked(endpoint)"
                                    [matTooltip]="!enableRemoveEndpoint ? ('policiesPage.deleteButtonTextHoverText' | labelsProvider) : ''" />
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <!-- When the table is empty ( data length 0) we get here -->
                <ng-template pTemplate=" emptymessage">
                    <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
                </ng-template>
            </p-table>
        </div>
    </div>

    <app-form-footer
        *ngIf="editable"
        [changesWereDone]="changesWereDone"
        (resetChanges)="resetForm()"
        (saveChanges)="updatePolicyConfig()"
        (cancelSettings)="cancelSettings()"></app-form-footer>

    <div *ngIf="isLoading$ | async" class="policy-endpoint-filtering-spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
</div>
